export default class StudioWriteDTO {
    public id: number | undefined;
    public name: string | undefined;
    public hostname: string | undefined;
    public rcpsPlayerId: number | undefined;
    public dealershipId: number | undefined;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'] || undefined;
        this.name = data['name'] || undefined;
        this.hostname = data['hostname'] || undefined;
        this.rcpsPlayerId = data['rcpsPlayerId'] || undefined;
        this.dealershipId = data['dealershipId'] || undefined;
    }
}
